import { ClientTokenRetrievalInfoModel, AuthInfo } from '../../../models/apiModels';

export interface HelpPaneServices {
    getClientToken: (clientWindow: any, clientTokenRetrievalInfoModel: ClientTokenRetrievalInfoModel) => Promise<AuthInfo>
}

export const helpPaneServices = (logClientDebuggingEvent: (
    behavior: number,
    formName: string,
    contentName: string,
    areaName: string,
    fileName: string,
    functionName: string,
    loggingArea: string,
    message: string) => void): HelpPaneServices => {
    const clientTokenDebugEvent = (functionName: string, loggingArea: string, message: string): void => {
        logClientDebuggingEvent(
            300,
            'maxFunnel',
            'signInButton',
            'modalitiesSection',
            'helpPaneServices.ts',
            functionName,
            loggingArea,
            message
        );
    };

    const getClientToken = (
        clientWindow: any,
        clientTokenRetrievalInfoModel: ClientTokenRetrievalInfoModel
    ): Promise<AuthInfo> => {
        let token: string = '';
        let promise: Promise<AuthInfo> = new Promise<AuthInfo>((resolve, _reject) => {
            resolve({ provider: '', token: '' });
        });
        let hasUserLoggedIntoClient: boolean = false;

        try {
            if (typeof clientWindow.PromptForLogin !== undefined &&
                typeof clientWindow.GetUserIdentityProvider !== undefined &&
                (typeof clientWindow.GetToken !== undefined || typeof clientWindow.GetTokenAsync !== undefined)) {
                hasUserLoggedIntoClient = clientWindow.PromptForLogin();

                if (hasUserLoggedIntoClient === true) {
                    if (typeof clientWindow.GetToken !== 'undefined') {
                        clientTokenDebugEvent(
                            'getClientToken',
                            'clientLogin',
                            `Going through GetToken synchronous path`
                        );

                        const loginProvider: string = clientWindow.GetUserIdentityProvider();

                        token = clientWindow.GetToken(
                            clientTokenRetrievalInfoModel.Encryption,
                            clientTokenRetrievalInfoModel.SiteDomain,
                            clientTokenRetrievalInfoModel.SignInEndpoint,
                            clientTokenRetrievalInfoModel.AADAppId);

                        promise = new Promise<AuthInfo>((resolve, _reject) => {
                            return resolve({
                                provider: loginProvider,
                                token: token,
                            });
                        });
                    } else if (typeof clientWindow.GetTokenAsync !== 'undefined') {
                        clientTokenDebugEvent(
                            'getClientToken',
                            'clientLogin',
                            `Going through GetTokenAsync asynchronous path`
                        );

                        promise = new Promise<AuthInfo>((resolve, _reject) => {
                            clientWindow.GetTokenAsync(
                                { resourceId: clientTokenRetrievalInfoModel.AADAppId, authorityUrl: clientTokenRetrievalInfoModel.SignInEndpoint },
                                { targetUrl: clientTokenRetrievalInfoModel.SiteDomain, policy: clientTokenRetrievalInfoModel.Encryption },
                                (response: any) => {
                                    resolve(response);
                                });
                        });
                    } else {
                        clientTokenDebugEvent(
                            'getClientToken',
                            'clientLoginError',
                            `client didn't provide a GetToken or GetTokenAsync function`
                        );
                    }
                } else {
                    clientTokenDebugEvent(
                        'getClientToken',
                        'clientLoginError',
                        `user didn't log in`
                    );
                }
            } else {
                clientTokenDebugEvent(
                    'getClientToken',
                    'clientLoginError',
                    `One or more of the client login APIs are undefined:
                    clientWindow.PromptForLogin:${typeof clientWindow.PromptForLogin}
                    clientWindow.GetUserIdentityProvider:${typeof clientWindow.GetUserIdentityProvider}
                    clientWindow.GetToken: ${typeof clientWindow.GetToken} clientWindow.GetTokenAsync: ${typeof clientWindow.GetTokenAsync}`
                );
            }
        } catch (e) {
            console.error(e);
            clientTokenDebugEvent(
                'getClientToken',
                'clientLoginError',
                `${JSON.stringify(e)} hasUserLoggedIntoClient: ${hasUserLoggedIntoClient}`
            );
        }

        return promise;
    };

    return {
        getClientToken: getClientToken,
    };
};
